var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaichiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#FFFFFF",
    stroke: "currentColor",
    viewBox: "0 0 442.88 340.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "c",
    d: "M0,181.92C59.6,132,118.44,80.57,179.14,32.65,208.68,9.33,243.23-.19,279.08,0c48.21.26,96.42.07,144.63.07h19.17C436.4,6.3,433.07,9.88,429.45,13Q351.92,78.5,274.28,143.89c-32.65,27.37-69.19,41.87-108.69,42.72-51.9,1.12-103.84.3-155.75.26-3,0-6-.51-9.07-.78C.51,184.7.26,183.31,0,181.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M2.57,228c47.85,0,95.7.45,143.55-.12,48.76-.59,95.71,9.25,140.71,32.43,32.09,16.53,64.37,32.55,96.54,48.86,17.05,8.64,34.06,17.4,54.61,27.91-6.23,1.23-9.17,2.32-12.1,2.32-52.4.09-104.95,3.06-157.13-1a335.68,335.68,0,0,1-103.51-24.9C112.45,291.18,61.61,262.12,10,235.85c-2.72-1.38-5.26-3.3-7.88-5C2.24,229.92,2.41,229,2.57,228Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaichiLogo);
export default __webpack_public_path__ + "static/media/taichi_logo.0cb828ff6139915a9dce74e74c3b12a5.svg";
export { ForwardRef as ReactComponent };